import { createSelector } from 'reselect';

import { State } from './types';

const selectOptionsState = (state: any) => state.options;

export const selectDisplaySearch = createSelector(
  [selectOptionsState],
  (state: State) => state.displaySearch
);

export const selectDisplayAddButton = createSelector(
  [selectOptionsState],
  (state: State) => state.displayAddButton
);

export const selectDisplayMenu = createSelector(
  [selectOptionsState],
  (state: State) => state.displayMenu
);

export const selectSearchTerm = createSelector(
  [selectOptionsState],
  (state: State) => state.searchTerm
);
